export var EnvEnum;
(function (EnvEnum) {
    EnvEnum["PRODUCTION"] = "production";
    EnvEnum["STAGING"] = "staging";
    EnvEnum["K8S_DEV"] = "k8s-dev";
    EnvEnum["DEVELOPMENT"] = "development";
    EnvEnum["TEST"] = "test";
})(EnvEnum || (EnvEnum = {}));
//# sourceMappingURL=EnvEnum.js.map